export enum Page {
	PLUGINS = "plugins",
	PLUGIN_DETAIL = "pluginDetail",
	METRICS = "metrics",
	VIEW_METRICS = "viewMetrics",
	SEARCH_METRICS = "searchMetrics",
	STYLEGUIDE = "styleGuide",
	QUIZ = "quiz",
	USERS = "users",
	GROUPS = "groups",
	WORKSPACE = "workspace",
	RESOURCES = "resources",
	MAIL = "mail",
	GUESTS = "guests",
	ACCESS_TOKENS = "accessTokens",
	LICENSE = "license",
}
